import { Moment } from 'moment';

import { openOrCloseGlobalDialog } from '../../action/dialog/global-dialog';
import { FAILURE, STARTING, SUCCESS } from '../../action/util/action-name-creators';
import { setJobSummariesDirty } from '../../job-summary/actions/set-job-summaries-dirty';
import { setEmployeeOrgMessagesDirty } from '../../messages/actions/set-employee-org-messages-dirty';
import { setJobApplicantJobMessagesDirty } from '../../messages/actions/set-job-applicant-job-messages-dirty';
import { setOrgJobApplicantMessagesDirty } from '../../messages/actions/set-org-job-applicant-messages-dirty';
import { createAction } from 'redux-actions';

import Contact from '../contact-api-client';

import { MESSAGE_TYPE } from '../../util/message-types';

export const INVALID_PHONE_NUMBER = 'INVALID_PHONE_NUMBER';
export const SEND_TEXT_MESSAGE = 'SEND_TEXT_MESSAGE';

const sendStart = createAction(STARTING(SEND_TEXT_MESSAGE));
const sendSuccess = createAction(SUCCESS(SEND_TEXT_MESSAGE));
const sendFailure = createAction(FAILURE(SEND_TEXT_MESSAGE));

const invalidPhoneNumber = createAction(INVALID_PHONE_NUMBER);

export const sendText =
  (
    contactId: number,
    context: ContactContextType,
    messageBody: string,
    messageType: string,
    subject?: string | null,
    messagesToClear?: {
      jobId?: number;
      orgId: number;
    },
    sendDateTime?: Moment | null,
    urlMappings?: Record<string, string>,
    sendVCardForOrgId?: number,
  ) =>
  async (dispatch: Function) => {
    if (messageType === MESSAGE_TYPE.TEXT) {
      dispatch(openOrCloseGlobalDialog('accountUnregisteredDialog', true));
    }
    dispatch(
      sendStart({
        contactId,
        messageBody,
        context,
      }),
    );
    const contact = new Contact(contactId);
    const response = await contact.sendText(
      messageBody,
      messageType,
      context,
      subject,
      sendDateTime,
      urlMappings,
      sendVCardForOrgId,
    );
    if (!response.ok) {
      dispatch(
        sendFailure({
          contactId,
          context,
        }),
      );
      return {
        errorMessage:
          "We're sorry, but there was a problem sending your message. Please try again later.",
      };
    }
    const message = await response.json();
    if (message.error && message.isPhoneNumberInvalid) {
      dispatch(
        invalidPhoneNumber({
          contactId,
          context,
        }),
      );
      dispatch(
        sendFailure({
          contactId,
          context,
        }),
      );
      return {
        errorMessage: 'Phone number is invalid',
      };
    }
    if (message.error) {
      dispatch(
        sendFailure({
          contactId,
          context,
        }),
      );
      return {
        errorMessage:
          "We're sorry, but there was a problem sending your message. Please try again later.",
      };
    }

    dispatch(
      sendSuccess({
        contactId,
        context,
        message,
      }),
    );

    if (messagesToClear) {
      const { orgId, jobId } = messagesToClear;
      dispatch(setJobSummariesDirty(orgId));
      if (jobId) {
        dispatch(setJobApplicantJobMessagesDirty(jobId));
      }
      if ('employeeId' in context) {
        dispatch(setEmployeeOrgMessagesDirty(orgId));
      } else if ('jobApplicantId' in context) {
        dispatch(setOrgJobApplicantMessagesDirty(orgId));
      }
    }

    return {};
  };
